import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../../src/context/userContext/userContext'; // Make sure this path is correct
import { throttle } from 'lodash';
import { v4 as uuidv4 } from 'uuid'; // UUID library to generate unique visit IDs

const PageAnalytics = ({ endpoint, children }) => {
  const [analyticsData, setAnalyticsData] = useState([]);
  const [visitId, setVisitId] = useState(sessionStorage.getItem('visitId') || uuidv4());
  const [startTime, setStartTime] = useState(Date.now());
  const location = useLocation();
  const { user, isLoading } = useContext(UserContext); // Fetch user and isLoading from context

  // Save visitId to sessionStorage
  useEffect(() => {
    if (!sessionStorage.getItem('visitId')) {
      sessionStorage.setItem('visitId', visitId);
    }
  }, [visitId]);

  // Function to collect data
  const collectData = (eventType, path = null, duration = null) => {
    const performanceEntries = performance.getEntriesByType('navigation');

    let pageLoadTime = null;
    let connectionInfo = null;
    let timeToFirstPaint = null;
    let emailToSend = '';
    let idToSend = '';
    let tokenToSend = '';

    if (localStorage.getItem('token')) {
      tokenToSend = localStorage.getItem('token');
    }

    if(user)
    {

    }

    // Only collect email if the user is loaded


    if (performanceEntries.length > 0) {
      const navigationTiming = performanceEntries[0];
      pageLoadTime = navigationTiming.loadEventEnd - navigationTiming.startTime;
      connectionInfo = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      timeToFirstPaint = navigationTiming.responseStart - navigationTiming.startTime;
    }

    const data = {
      token: tokenToSend,
      userID: idToSend,
      userEmail: emailToSend,
      visitId,
      eventType,
      timestamp: new Date().toISOString(),
      pageUrl: window.location.href,
      referrer: document.referrer || 'Direct',
      userAgent: navigator.userAgent,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      deviceType: /Mobi|Tablet|iPad|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop',
      path,
      duration,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      scrollPositionX: window.scrollX,
      scrollPositionY: window.scrollY,
      orientation: window.screen.orientation ? window.screen.orientation.type : 'unknown',
      connectionType: connectionInfo ? connectionInfo.effectiveType : 'unknown',
      bandwidth: connectionInfo ? connectionInfo.downlink : null,
      rtt: connectionInfo ? connectionInfo.rtt : null,
      pageLoadTime: pageLoadTime || null,
      timeToFirstPaint: timeToFirstPaint || null,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown',
    };

    setAnalyticsData((prevData) => [...prevData, data]);
  };

  // Track page view on route change
  useEffect(() => {
    collectData('pageView', location.pathname);
  }, [location.pathname]);

  // Track changes to user and update analytics
//   useEffect(() => {
//     collectData('userUpdate');
//   }, [user]);

  // Page visibility and duration tracking
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        collectData('pageHidden', null, Date.now() - startTime);
      } else {
        setStartTime(Date.now());
        collectData('pageVisible');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [startTime]);

  // Throttled scroll event
  const handleScroll = throttle(() => {
    collectData('scroll');
  }, 500);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to send data to the server
  const sendAnalytics = async () => {
    if (analyticsData.length > 0) {
      try {
        await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(analyticsData),
        });
        setAnalyticsData([]); // Clear data after successful send
      } catch (error) {
        console.error('Error sending analytics data', error);
      }
    }
  };

  // Send analytics data every 3 seconds
  useEffect(() => {
    const interval = setInterval(sendAnalytics, 3000);
    return () => clearInterval(interval);
  }, [analyticsData, endpoint]);

  // Ensure data is sent when the user exits the page
  const handleBeforeUnload = (event) => {
    collectData('pageExit', null, Date.now() - startTime);
    const finalData = [...analyticsData, {
      visitId,
      eventType: 'pageExit',
      timestamp: new Date().toISOString(),
      duration: Date.now() - startTime,
    }];

    // Use navigator.sendBeacon for reliability
    navigator.sendBeacon(endpoint, JSON.stringify(finalData));
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [analyticsData, endpoint]);

  return <>{children}</>;
};

export default PageAnalytics;


// import React, { useEffect, useState, useContext } from 'react';
// import { useLocation } from 'react-router-dom';
// import { UserContext } from '../../src/context/userContext/userContext'; // Make sure this path is correct
// import { throttle } from 'lodash';
// import { v4 as uuidv4 } from 'uuid'; // UUID library to generate unique visit IDs

// const PageAnalytics = ({ endpoint, children }) => {
//   const [analyticsData, setAnalyticsData] = useState([]);
//   const [visitId, setVisitId] = useState(sessionStorage.getItem('visitId') || uuidv4());
//   const [startTime, setStartTime] = useState(Date.now());
//   const location = useLocation();
//   const { user, isLoading } = useContext(UserContext); // Fetch user and isLoading from context

//   // Save visitId to localStorage if not already set
//   useEffect(() => {
//     if (!sessionStorage.getItem('visitId')) {
//         sessionStorage.setItem('visitId', visitId);
//     }
//   }, [visitId]);


//   // Function to collect data
//   const collectData = (eventType, path = null, duration = null) => {
//     const performanceEntries = performance.getEntriesByType('navigation');

//     let pageLoadTime = null;
//     let connectionInfo = null;
//     let timeToFirstPaint = null;
//     let emailToSend = '';
//     let idToSend = '';
//     let tokenToSend = '';

//     if(localStorage.getItem('token'))
//     {
//         tokenToSend = localStorage.getItem('token')
//     }

//     // Only collect email if the user is loaded
//     if (!isLoading && user && user.email && user.id) {
//       emailToSend = user.email;  // Use the user email directly
//       idToSend = user.id;
//     }

//     if (performanceEntries.length > 0) {
//       const navigationTiming = performanceEntries[0]; // Get the first navigation entry    
//       pageLoadTime = navigationTiming.loadEventEnd - navigationTiming.startTime; // Calculate page load time
//       connectionInfo = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
//       timeToFirstPaint = navigationTiming.responseStart - navigationTiming.startTime;      
//     }


//     const data = {

//       userID: idToSend,
//       userEmail: emailToSend, // email address of user if logged in
//       visitId, // Unique ID for the session
//       eventType, // e.g., 'pageView', 'scroll', 'pageHidden'
//       timestamp: new Date().toISOString(), // Current timestamp
//       pageUrl: window.location.href, // Full URL of the page
//       referrer: document.referrer || 'Direct', // Referrer URL or 'Direct' if none
//       userAgent: navigator.userAgent, // User agent string
//       screenResolution: `${window.screen.width}x${window.screen.height}`, // Screen resolution
//       deviceType: /Mobi|Tablet|iPad|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop', // Device type
//       path, // The pathname (route) of the page (for 'pageView' events)
//       duration, // Time spent on the page (for 'pageHidden' events)
//       viewportWidth: window.innerWidth,
//       viewportHeight: window.innerHeight,
//       scrollPositionX: window.scrollX,
//       scrollPositionY: window.scrollY,
//       orientation: window.screen.orientation ? window.screen.orientation.type : 'unknown',
//       connectionType: connectionInfo ? connectionInfo.effectiveType : 'unknown',
//       bandwidth: connectionInfo ? connectionInfo.downlink : null,
//       rtt: connectionInfo ? connectionInfo.rtt : null,
//       pageLoadTime: pageLoadTime || null,
//       timeToFirstPaint: timeToFirstPaint || null,
//       timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown',
//     };

//     setAnalyticsData((prevData) => [...prevData, data]);
//   };

//   // Track page view on route change
//   useEffect(() => {
//     //submitData('pageView');
//     collectData('pageView', location.pathname);
//   }, [location.pathname]);

//   // Track changes to user and update analytics
//   useEffect(() => {
//     //submitData('userUpdate');
//     collectData('userUpdate');
//   }, [user]); // This ensures collectData runs every time the user changes

// // useEffect(() =>{


// // })

//   // Page visibility and duration tracking
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.visibilityState === 'hidden') {
//         collectData('pageHidden', null, Date.now() - startTime);
//       } else {
//         setStartTime(Date.now());
//         collectData('pageVisible');
//       }
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     return () => {
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//     };
//   }, [startTime]);

//   // Throttled scroll event
//   const handleScroll = throttle(() => {
//     //submitData("scroll");
//     collectData('scroll');
//   }, 500);

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   // Periodically send the data to the server
//   useEffect(() => {
//     const sendAnalytics = async () => {

//         console.log("data length:", analyticsData.length)
//       if (analyticsData.length > 0) {
//         try {
//           await fetch(endpoint, {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(analyticsData),
//           });
//           setAnalyticsData([]); // Clear data after successful send
//         } catch (error) {
//           console.error('Error sending analytics data', error);
//         }
//       }
//     };

//     const interval = setInterval(sendAnalytics, 3000); // Send every 3 seconds
//     return () => clearInterval(interval); // Cleanup interval on component unmount
//   }, [analyticsData, endpoint]);

//   // Render the children along with analytics tracking
//   return <>{children}</>;
// };

// export default PageAnalytics;














// import React, { useEffect, useState, useContext } from 'react';
// import { useLocation } from 'react-router-dom';
// import { UserContext } from '../../context/userContext';
// import { throttle } from 'lodash';
// import { v4 as uuidv4 } from 'uuid'; // UUID library to generate unique visit IDs

// const PageAnalytics = ({ endpoint, children }) => {
//   const [analyticsData, setAnalyticsData] = useState([]);
//   const [visitId, setVisitId] = useState(localStorage.getItem('visitId') || uuidv4());
//   const [startTime, setStartTime] = useState(Date.now());
//   const location = useLocation();
//   const{user, isLoading} = useContext(UserContext);
  
//   // Save visitId to localStorage if not already set
//   useEffect(() => {
//     if (!localStorage.getItem('visitId')) {
//       localStorage.setItem('visitId', visitId);
//     }
//   }, [visitId]);

  

//   // Function to collect data
//   const collectData = (eventType, path = null, duration = null) => {
    
//     const performanceEntries = performance.getEntriesByType('navigation');
    
//     const pageLoadTime = null;
//     var connectionInfo = null;
//     var timeToFirstPaint = null;
//     var email = "";
//     //console.log("USER: ", user)
//     if(user)
//     {
//       email = user.email
//     }

//     if (performanceEntries.length > 0) {
//       const navigationTiming = performanceEntries[0]; // Get the first navigation entry    
//       const pageLoadTime = navigationTiming.loadEventEnd - navigationTiming.startTime; // Calculate page load time
//       connectionInfo = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
//       const timeToFirstPaint = navigationTiming.responseStart - navigationTiming.startTime;
//       console.log('Page Load Time:', pageLoadTime);    }


//     const data = {

//       userEmail: email, // email address of user if logged in
//       visitId, // Unique ID for the session
//       eventType, // e.g., 'pageView', 'scroll', 'pageHidden'
//       timestamp: new Date().toISOString(), // Current timestamp
//       pageUrl: window.location.href, // Full URL of the page
//       referrer: document.referrer || 'Direct', // Referrer URL or 'Direct' if none
//       userAgent: navigator.userAgent, // User agent string
//       screenResolution: `${window.screen.width}x${window.screen.height}`, // Screen resolution
//       deviceType: /Mobi|Tablet|iPad|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop', // Device type
//       path, // The pathname (route) of the page (for 'pageView' events)
//       duration, // Time spent on the page (for 'pageHidden' events)
//       viewportWidth: window.innerWidth,
//       viewportHeight: window.innerHeight,
//       orientation: window.screen.orientation ? window.screen.orientation.type : 'unknown',
//       connectionType: connectionInfo.effectiveType || 'unknown',
//       bandwidth: connectionInfo.downlink || null,
//       rtt: connectionInfo.rtt || null,
//       pageLoadTime: pageLoadTime || null,
//       timeToFirstPaint: timeToFirstPaint || null,
//       timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown',
    
//     };

//     setAnalyticsData((prevData) => [...prevData, data]);
//   };

//   // Track page view on route change
//   useEffect(() => {
//     collectData('pageView', location.pathname);
//   }, [location.pathname]);

//   // Page visibility and duration tracking
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.visibilityState === 'hidden') {
//         collectData('pageHidden', null, Date.now() - startTime);
//       } else {
//         setStartTime(Date.now());
//         collectData('pageVisible');
//       }
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     return () => {
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//     };
//   }, [startTime]);

//   // Throttled scroll event
//   const handleScroll = throttle(() => {
//     collectData('scroll');
//   }, 500);

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   // Periodically send the data to the server
//   useEffect(() => {
//     const sendAnalytics = async () => {
//       if (analyticsData.length > 0) {
//         try {
//           await fetch(endpoint, {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(analyticsData),
//           });
//           setAnalyticsData([]); // Clear data after successful send
//         } catch (error) {
//           console.error('Error sending analytics data', error);
//         }
//       }
//     };

//     const interval = setInterval(sendAnalytics, 10000); // Send every 10 seconds
//     return () => clearInterval(interval); // Cleanup interval on component unmount
//   }, [analyticsData, endpoint]);

//   // Render the children along with analytics tracking
//   return <>{children}</>;
// };

// export default PageAnalytics;



// // import React, { useEffect, useState } from 'react';
// // import { useLocation } from 'react-router-dom';
// // import { throttle } from 'lodash';
// // import { v4 as uuidv4 } from 'uuid';

// // const PageAnalytics = ({ endpoint, children }) => {
// //   const [analyticsData, setAnalyticsData] = useState([]);
// //   const [visitId, setVisitId] = useState(localStorage.getItem('visitId') || uuidv4());
// //   const [startTime, setStartTime] = useState(Date.now());
// //   const location = useLocation();

// //   // Save visitId to localStorage if not already set
// //   useEffect(() => {
// //     if (!localStorage.getItem('visitId')) {
// //       localStorage.setItem('visitId', visitId);
// //     }
// //   }, [visitId]);

// //   // Collect data without needing special permissions
// //   const collectData = (eventType, path = null, duration = null) => {
// //     const connectionInfo = navigator.connection || {};
// //     const performanceData = window.performance.timing;

// //     const data = {
// //       visitId,
// //       eventType,
// //       timestamp: new Date().toISOString(),
// //       pageUrl: window.location.href,
// //       referrer: document.referrer || 'Direct',
// //       userAgent: navigator.userAgent,
// //       screenResolution: `${window.screen.width}x${window.screen.height}`,
// //       deviceType: /Mobi|Tablet|iPad|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop',
// //       viewportWidth: window.innerWidth,
// //       viewportHeight: window.innerHeight,
// //       connectionType: connectionInfo.effectiveType || 'unknown',
// //       bandwidth: connectionInfo.downlink || 'unknown',
// //       pageLoadTime: performanceData.loadEventEnd - performanceData.navigationStart || 0,
// //       timeToFirstPaint: performanceData.responseStart - performanceData.navigationStart || 0,
// //       timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown',
// //     };

// //     setAnalyticsData((prevData) => [...prevData, data]);
// //   };

// //   // Track page view on route change
// //   useEffect(() => {
// //     collectData('pageView', location.pathname);
// //   }, [location.pathname]);

// //   // Track scroll depth (throttled)
// //   const handleScroll = throttle(() => {
// //     collectData('scroll');
// //   }, 500);

// //   useEffect(() => {
// //     window.addEventListener('scroll', handleScroll);

// //     return () => {
// //       window.removeEventListener('scroll', handleScroll);
// //     };
// //   }, []);

// //   // Periodically send the data to the server
// //   useEffect(() => {
// //     const sendAnalytics = async () => {
// //       if (analyticsData.length > 0) {
// //         try {
// //           await fetch(endpoint, {
// //             method: 'POST',
// //             headers: {
// //               'Content-Type': 'application/json',
// //             },
// //             body: JSON.stringify({ analyticsData }),
// //           });
// //           setAnalyticsData([]); // Clear data after successful send
// //         } catch (error) {
// //           console.error('Error sending analytics data', error);
// //         }
// //       }
// //     };

// //     const interval = setInterval(sendAnalytics, 10000); // Send every 10 seconds
// //     return () => clearInterval(interval);
// //   }, [analyticsData, endpoint]);

// //   // Render the children and track analytics
// //   return <>{children}</>;
// // };

// // export default PageAnalytics;
